const CACHE_BUSTER_PARAM = '_jsonv'
const DEFAULT_CACHE_BUSTER = 'raysync-json-refresh-20260703-1'

let installed = false

const cacheBuster =
  (typeof process !== 'undefined' && process.env && process.env.GATSBY_JSON_CACHE_BUSTER_ID) || DEFAULT_CACHE_BUSTER

const shouldBustUrl = url => {
  if (typeof window === 'undefined' || !url) return false
  try {
    const parsedUrl = new URL(url, window.location.href)
    return parsedUrl.origin === window.location.origin && /\.json$/i.test(parsedUrl.pathname)
  } catch (error) {
    return false
  }
}

const addJsonCacheBuster = url => {
  if (!shouldBustUrl(url)) return url

  const parsedUrl = new URL(url, window.location.href)
  if (!parsedUrl.searchParams.has(CACHE_BUSTER_PARAM)) {
    parsedUrl.searchParams.set(CACHE_BUSTER_PARAM, cacheBuster)
  }

  return parsedUrl.toString()
}

const installXhrCacheBuster = () => {
  if (typeof XMLHttpRequest === 'undefined') return

  const originalOpen = XMLHttpRequest.prototype.open
  if (!originalOpen || originalOpen.__jsonCacheBusterPatched) return

  function open(method, url, ...args) {
    return originalOpen.call(this, method, typeof url === 'string' ? addJsonCacheBuster(url) : url, ...args)
  }

  open.__jsonCacheBusterPatched = true
  XMLHttpRequest.prototype.open = open
}

const installFetchCacheBuster = () => {
  if (typeof window === 'undefined' || typeof window.fetch !== 'function') return

  const originalFetch = window.fetch
  if (originalFetch.__jsonCacheBusterPatched) return

  function fetchWithJsonCacheBuster(input, init) {
    if (typeof input === 'string') {
      return originalFetch.call(this, addJsonCacheBuster(input), init)
    }

    if (input instanceof URL) {
      return originalFetch.call(this, addJsonCacheBuster(input.toString()), init)
    }

    return originalFetch.call(this, input, init)
  }

  fetchWithJsonCacheBuster.__jsonCacheBusterPatched = true
  window.fetch = fetchWithJsonCacheBuster
}

const installLinkCacheBuster = () => {
  if (typeof HTMLLinkElement === 'undefined') return

  const originalSetAttribute = HTMLLinkElement.prototype.setAttribute
  if (!originalSetAttribute || originalSetAttribute.__jsonCacheBusterPatched) return

  function setAttribute(name, value) {
    const nextValue =
      String(name).toLowerCase() === 'href' && typeof value === 'string' ? addJsonCacheBuster(value) : value
    return originalSetAttribute.call(this, name, nextValue)
  }

  setAttribute.__jsonCacheBusterPatched = true
  HTMLLinkElement.prototype.setAttribute = setAttribute

  const descriptor = Object.getOwnPropertyDescriptor(HTMLLinkElement.prototype, 'href')
  if (!descriptor || !descriptor.set || descriptor.set.__jsonCacheBusterPatched) return

  function setHref(value) {
    return descriptor.set.call(this, typeof value === 'string' ? addJsonCacheBuster(value) : value)
  }

  setHref.__jsonCacheBusterPatched = true
  Object.defineProperty(HTMLLinkElement.prototype, 'href', {
    ...descriptor,
    set: setHref,
  })
}

const installJsonCacheBuster = () => {
  if (process.env.NODE_ENV !== 'production') return
  if (installed || typeof window === 'undefined') return
  installed = true
  installXhrCacheBuster()
  installFetchCacheBuster()
  installLinkCacheBuster()
}

module.exports = {
  addJsonCacheBuster,
  installJsonCacheBuster,
}
